import React from 'react'
import { Component } from 'reflux'
import DynamicTable from 'Components/dynamicTable'
import CollapsibleCard from 'Components/collapsibleCard'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import { Button, ButtonGroup, UncontrolledTooltip as Tooltip } from 'reactstrap'
import { toast } from 'react-toastify'
import { ExpectedDeliveryStatusActions, ExpectedDeliveryStatusStore, STATUS } from 'Stores/expectedDeliveryStatusStore'
import moment from 'moment'
import ExpectedDeliveryStatusLinkModal from './expectedDeliveryStatusLinkModal'

export default class ExpectedDeliverySupplierOverview extends Component {
  constructor(props) {
    super(props)
    this.stores = [ExpectedDeliveryStatusStore]
    this.storeKeys = ['allSupplierLinks', 'status', 'suppliers', 'showAddLinkModalType']
    this.state = {
      selectedSupplierID: null
    }
  }

  componentDidMount() {
    ExpectedDeliveryStatusActions.fetchSupplierLinks()
    ExpectedDeliveryStatusActions.getSuppliers()
  }

  componentDidUpdate() {
    if (this.state.status === STATUS.FETCHING_ERROR) {
      toast.error('Fetching links failed', {
        autoClose: 7500,
        onClose: () => {
          ExpectedDeliveryStatusActions.clearToast()
        }
      })
      ExpectedDeliveryStatusActions.clearToast()
    }
  }

  render() {
    if (this.state.status === STATUS.IS_FETCHING) {
      return <FontAwesomeIcon icon='spinner' spin />
    }

    const suppliersWithoutLinks = this.state.suppliers.filter(
      supplier => !this.state.allSupplierLinks.some(link => link.SupplierID === supplier.SupplierID)
    )

    return (
      <React.Fragment>
        <CollapsibleCard startOpen header={<strong>Leverandører uden leveringsstatus</strong>}>
          <DynamicTable
            responsive
            size='sm'
            options={{
              startSort: {
                dir: 'DESC',
                column: 'SupplierID'
              },
              fieldFunctions: {
                supplierName: e => {
                  return <Link to={`/suppliers/${e.SupplierID}`}>{e.supplierName}</Link>
                }
              },
              addField: e => {
                return (
                  <td>
                    <Button
                      onClick={() => {
                        this.setState({ selectedSupplierID: e.SupplierID })
                        ExpectedDeliveryStatusActions.setAddLinkModalType('ExpectedDeliveryStatus')
                      }}
                      style={{ marginLeft: 'auto', display: 'block' }}
                    >
                      Tilføj status
                    </Button>
                  </td>
                )
              }
            }}
            headers={{
              supplierName: 'Leverandør'
            }}
            data={suppliersWithoutLinks}
          />
        </CollapsibleCard>
        <CollapsibleCard startOpen header={<strong>Leverandør Links</strong>}>
          <DynamicTable
            responsive
            size='sm'
            options={{
              startSort: {
                dir: 'DESC',
                column: 'SupplierExpectedDeliveryStatusID'
              },
              fieldFunctions: {
                supplierName: e => {
                  return (
                    <Link to={`/suppliers/${e.SupplierID}`}>
                      {this.state.suppliers.find(supplier => supplier.SupplierID === e.SupplierID)?.supplierName}
                    </Link>
                  )
                },
                timeStart: e => {
                  if (e.timeStart) {
                    return moment(e.timeStart).format('YYYY-MM-DD')
                  }
                },
                timeEnd: e => {
                  if (e.timeEnd) {
                    return moment(e.timeEnd).format('YYYY-MM-DD')
                  }
                }
              },
              fieldStringFunctions: {
                supplierName: e => {
                  return this.state.suppliers.find(supplier => supplier.SupplierID === e.SupplierID)?.supplierName
                },
                timeStart: e => {
                  return moment(e.timeStart).format('x')
                },
                timeEnd: e => {
                  return moment(e.timeEnd).format('x')
                }
              },
              addField: e => {
                return (
                  <td style={{ display: 'flex', justifyContent: 'end' }}>
                    <ButtonGroup>
                      <Tooltip target={'delete' + e.SupplierID}>Slet</Tooltip>
                      <Button
                        id={'delete' + e.SupplierID}
                        onClick={() => {
                          if (confirm('Vil du slette dette link?')) {
                            ExpectedDeliveryStatusActions.deleteSupplierLink(e.SupplierExpectedDeliveryStatusID)
                          }
                        }}
                        color='danger'
                      >
                        <FontAwesomeIcon icon='trash' />
                      </Button>
                    </ButtonGroup>
                  </td>
                )
              }
            }}
            headers={{
              SupplierExpectedDeliveryStatusID: 'ID',
              supplierName: 'Leverandør',
              expectedDeliveryStatusName: 'Leveringsstatus',
              timeStart: 'Start',
              timeEnd: 'End'
            }}
            data={this.state.allSupplierLinks}
          />
        </CollapsibleCard>

        <ExpectedDeliveryStatusLinkModal
          SupplierID={this.state.selectedSupplierID}
          isOpen={!!this.state.showAddLinkModalType}
          toggle={() => ExpectedDeliveryStatusActions.setAddLinkModalType(null)}
          linkType={this.state.showAddLinkModalType}
        />
      </React.Fragment>
    )
  }
}
